export * from './private-office-block.module';
